<template>
    <div>
        <f-dialog
            v-model       = "edit"
            :width        = "550"
            :show-header  = "false"
            :hide-actions = "true"
            content-class = "dialog-border"
            @cancel       = "onCancel"
        >
            <template v-slot:content>
                <div style="position: relative" class="pl-2 mr-2">
                    <div class="close-button">
                        <c-toolbar-button
                            size     = "28"
                            color    = "red"
                            icon     = "mdi-close"
                            :tooltip = "$t('common.cancel')"
                            @click   = "onCancel"
                        />
                    </div>

                    <div class="mb-5">
                        <div class="doc-header">
                            Aktuelle Version
                        </div>
                        <div class="date-header primary--text v-flex">
                            Dokumentenart / Name
                            <v-spacer />

                            <div class="header-title primary--text">
                                Erstellung am / von
                            </div>
                        </div>
                        <v-card
                            flat
                            class  = "lm-border doc-entry mb-1 mr-1"
                            @click = "onShowDocument"
                        >
                            <div style="display: block" class="pl-2 doc-col">
                                <div class="doc-info v-flex">
                                    <!-- unit chip -->
                                    <div v-if="document.unitName" class="doc-unit mr-1 primary white--text">
                                        {{ document.unitName }}
                                    </div>
                                    <!-- unit chip -->

                                    <!-- document type -->
                                    <div>
                                        {{ document.type ? document.type.name : '---' }}
                                    </div>
                                    <!-- document type -->

                                    <v-spacer />
                                </div>

                                <div class="doc-subinfo doc-filename">
                                    {{ document.name }}
                                </div>
                            </div>

                            <v-spacer  />

                            <div style="display: block; margin-right: 24px" >
                                <div class="doc-date pr-2">
                                    {{ timeAsString(document.createdDate) }}
                                </div>
                                <div class="doc-subinfo">
                                    {{ document.createdBy }}
                                </div>
                            </div>
                        </v-card>

                        <div class="doc-header" v-if="versions">
                            Frühere Versionen
                        </div>
                        <div class="date-header primary--text v-flex" v-if="versions">
                            Name / Version
                            <v-spacer />

                            <div class="header-title primary--text">
                                Erstellung am / von
                            </div>
                        </div>

                        <div class="scroll-area" v-if="versions">
                            <a
                                v-for  = "(version, index) in versions"
                                :key   = "index"
                            >
                                <v-hover
                                    v-slot = "{ hover }"
                                >
                                    <p-dms-version
                                        :document     = "document"
                                        :version      = "version"
                                        :step-data-id = "stepDataId"
                                        :hover        = "hover"
                                        @removed      = "onRemoved"
                                    />
                                </v-hover>
                            </a>
                        </div>
                    </div>
                </div>
            </template>
        </f-dialog>
    </div>
</template>

<script>

import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import FDialog from "@/modules/core/components/utils/FDialog.vue";
import Core from "@/modules/core/service/Core";
import PDmsVersion from "@/modules/dms/menu/components/private/PDmsVersion.vue";
import Dms from "@/modules/dms/common/service/Dms";
import Inc from "@/modules/inc/service/Inc";

export default {
    name: "PDmsVersions",

    components: {
        PDmsVersion,
        CToolbarButton,
        FDialog
    },

    props: {
        stepDataId: {

        },

        document: {

        },

        value: {

        }
    },

    data: () => ({
        type    : null,
        filename: null,
        edit    : false,
        versions: null,
    }),

    computed: {
        size () {
            if (!this.document.size) {
                return null;
            }

            return ((this.document.size / 1024) | 0) + " KB"
        },
    },

    mounted() {
    },

    watch: {
        value () {
            this.edit = this.value;
            if (this.edit) {
                this.load();
            }
        }
    },

    methods: {
        load () {
            Inc.document.versions.get (this.document.id).then(data => {
                this.versions = data.versions;
                if (this.versions && this.versions.length === 0) {
                    this.versions = null;
                }
            });
        },

        onRemoved () {
            this.load();
        },

        onCancel () {
            this.$emit("input", false);
        },

        /**
         * Called when the user selects a document by the document's context menu.
         */
        onShowDocument () {
            Dms.open(this.document.id, this.document.name);
        },

        format (value) {
            if (!value) {
                return "---"
            }
            return Core.format.datetime.display(value);
        },

        timeAsString (value) {
            return Core.format.datetime.display(value);
        }
    }
}
</script>

<style scoped>

.scroll-area {
    max-height: 580px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.close-button {
    position: absolute;
    z-index: 10;
    right: 0;
    top: -4px;
}

::v-deep .doc-entry {
    font-size: 15px;
    min-height: 35px;
    border-radius: 0!important;
    display: flex;
}

.doc-info {
    font-size: 14px;
    padding-top: 1px;
}

.doc-col {
    padding-top: 2px;
    padding-bottom: 5px;
}

.doc-date {
    font-size: 12px;
    margin-top: 4px;
}

.doc-subinfo {
    font-size: 11px;
    margin-top: 0!important;
    margin-bottom: -4px!important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.doc-header {
    font-size: 18px;
    font-weight: 600;
    max-width: 490px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: black;
    margin-top: 16px;
}

.date-header {
    font-size: 14px;
    margin-left: 0;
    margin-top: 8px;
    margin-bottom: 0;
    color: black;
    margin-right: 8px;
}

.doc-filename {
    max-width: 220px;
    width: 220px;
}

</style>